import {Box, DialogActions, DialogContent, DialogTitle, Tooltip} from "@mui/material";
import Button from "../../base/button/button";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Dialog from "../../base/dialog";
import ManageProductDimensions from "../../app-specific/manage-product-dimensions";


const ManageProductDimensionsDialog = ({
                                           partNo,
                                           partId,
                                           close,
                                           open,
                                           onDimensionSelected,
                                       }) => {
    const [selectedDimension, setSelectedDimension] = useState(null);
    const dimensionsRef = useRef(null);

    /**
     * Reset selected dimension when dialog is closed
     */
    useEffect(() => {
        if (open) {
            setSelectedDimension(null);
        }
    }, [open]);

    /**
     * Closes the dialog and also passes the list of dimensions.
     * @type {(function(): void)}
     */
    const closeDialog = useCallback(() => {
        const dimensions = dimensionsRef.current?.getDimensions();
        const loadingState = dimensionsRef.current?.getLoadingState();
        close?.({dimensions, loadingState});
    }, [close])

    return (
        <>
            <Dialog
                maxWidth={'md'}
                open={open}
                setOpen={() => closeDialog()}
            >
                <DialogTitle fontWeight={600}>
                    Manage Dimensions of {partNo ?? ""}
                </DialogTitle>
                <DialogContent dividers className={'py-3'}>
                    <ManageProductDimensions
                        partId={partId}
                        partNo={partNo}
                        selectedId={selectedDimension?.uniqueId}
                        onSelect={!!onDimensionSelected ? setSelectedDimension : undefined}
                        ref={dimensionsRef}
                    />
                </DialogContent>
                <DialogActions sx={{display: 'flex', justifyContent: 'space-between', padding: 0}}>
                    <Button
                        variant={'dialog'}
                        type={'button'}
                        color={'primary'}
                        onClick={() => closeDialog()}
                        borderRadius={'0 8px 0 8px'}
                    >
                        Close
                    </Button>
                    {
                        onDimensionSelected &&
                        <Tooltip title={!selectedDimension ? "Please select a dimension from the list or create a new one to proceed." : ""}>
                            <Box component={'span'}>
                                <Button
                                    variant={'dialog'}
                                    color={'primary'}
                                    borderRadius={'8px 0 8px 0'}
                                    disabled={!selectedDimension}
                                    onClick={() => {
                                        onDimensionSelected(selectedDimension);
                                        closeDialog();
                                    }}
                                >
                                    {
                                        !!selectedDimension
                                            ? "Choose this Dimension"
                                            : "Choose a Dimension"
                                    }
                                </Button>
                            </Box>
                        </Tooltip>
                    }
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ManageProductDimensionsDialog;